document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const merchParam = params.get('merch');
  if (!merchParam) return;

  const grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  const ruleEls = document.querySelectorAll('[data-merch-sort-rule]');
  if (!ruleEls.length) return;

  let rule;
  for (const ruleEl of ruleEls) {
    let parsed;
    try {
      parsed = JSON.parse(ruleEl.textContent);
    } catch (e) {
      continue;
    }

    if (!parsed.merch_key || parsed.merch_key !== merchParam) continue;
    if (!parsed.assigned_collection || parsed.assigned_collection !== parsed.current_collection) continue;
    if (!Array.isArray(parsed.products) || parsed.products.length === 0) continue;

    rule = parsed;
    break;
  }

  if (!rule) return;

  const items = Array.from(grid.children);
  const byHandle = new Map(items.map((el) => [el.dataset.handle, el]));

  const ordered = [
    ...rule.products.map((h) => byHandle.get(h)).filter(Boolean),
    ...items.filter((el) => !rule.products.includes(el.dataset.handle)),
  ];

  ordered.forEach((el) => grid.appendChild(el));
});
